import { render, staticRenderFns } from "./SignInModal.vue?vue&type=template&id=a878f7e6&scoped=true&"
import script from "./SignInModal.vue?vue&type=script&lang=js&"
export * from "./SignInModal.vue?vue&type=script&lang=js&"
import style0 from "./SignInModal.vue?vue&type=style&index=0&id=a878f7e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a878f7e6",
  null
  
)

export default component.exports